import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SiteAdminService {
  private _maxUsers?: number;

  /**
   * Set the number of maximum users
   */
  public set maxUsers(v: number | undefined) {
    this._maxUsers = v;
  }
  /**
   * Get the number of maximum users, unlimited if undefined
   */
  public get maxUsers(): number | undefined {
    return this._maxUsers;
  }

}
